import type { ReactElement } from 'react';
import { cloneElement } from 'react';

import type {
  MBDAttributes,
  MBDParams,
} from '@shared/types/frontend/meaningful-behaviour-data';

import generateTrackingAttributes from '@shared/utils-frontend/meaningful-behaviour-data/generate-tracking-attributes';

type Props = {
  id?: string;
  name?: string;
  params?: MBDParams;
  children: ReactElement;
};

const MeaningfulBehaviourDataWrapper = ({
  children,
  id,
  name,
  params,
}: Props) => {
  if (!id || !name) {
    return children;
  }

  const mbdAttributes: MBDAttributes = generateTrackingAttributes(
    id,
    name,
    params,
  );

  return <>{cloneElement(children, { ...mbdAttributes })}</>;
};

export default MeaningfulBehaviourDataWrapper;
